var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircleGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0F8482",
    fillRule: "evenodd",
    d: "M12 .375c2.094 0 4.031.523 5.812 1.57 1.782 1.047 3.196 2.461 4.243 4.243 1.047 1.78 1.57 3.718 1.57 5.812 0 2.094-.523 4.031-1.57 5.813-1.047 1.78-2.461 3.195-4.243 4.242-1.78 1.047-3.718 1.57-5.812 1.57-2.094 0-4.031-.523-5.813-1.57-1.78-1.047-3.195-2.461-4.242-4.242C.898 16.03.375 14.093.375 12c0-2.094.523-4.031 1.57-5.812 1.047-1.782 2.461-3.196 4.242-4.243C7.97.898 9.907.375 12 .375zm5.86 7.5c-.157 0-.298.047-.423.14l-7.64 7.641-3.235-3.281c-.125-.094-.265-.14-.421-.14-.157 0-.282.046-.375.14l-.422.375c-.094.125-.14.266-.14.422 0 .156.046.281.14.375l4.031 4.078c.125.125.266.188.422.188.156 0 .281-.063.375-.188l8.484-8.39c.094-.094.14-.22.14-.376s-.046-.296-.14-.421l-.422-.375c-.093-.125-.218-.188-.375-.188z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleGreen);
export default __webpack_public_path__ + "static/media/check-circle-green.7fd1ad808123abbcf068c59fb1641846.svg";
export { ForwardRef as ReactComponent };